export class GroupContacts {
  public impressionAddressOrder?: string;

  constructor(data?: Partial<GroupContacts>) {
    Object.assign(this, data);
  }
}

export class GroupContactsForRecipient {
  id: number;
  description: string;
  name: string;
  type: string;
}
